import { z } from 'zod';

// // Default schema with static message for backward compatibility
// export const subscribeNewsletterSchema = z.object({
//     email: z.string().email({ message: 'Invalid email format' }),
// });

// Function to create schema with translations
export const createSubscribeNewsletterSchema = (t: (key: string) => string) => {
    return z.object({
        email: z.string().email({ message: t('invalid-email-format') }),
    });
};

export type SubscribeNewsletterValues = z.infer<ReturnType<typeof createSubscribeNewsletterSchema>>;
